export const env = (key: string, throwOnMissing = false): string | null => {
  if (typeof document !== 'undefined' && typeof import.meta !== 'undefined' && import.meta.env) {
    if (throwOnMissing && !import.meta.env[key]) {
      throw new Error(`Environment variable ${key} is not set`);
    }
    return import.meta.env[key] ?? null;
  }
  return null;
};
